import axios from "axios";
import { useCallback, useEffect, useState } from "react";

const getBaseUrl = () => {
  // Deployed environments proxy /api on their own origin; only local dev has no backend of its own.
  const origin = window.location.origin;
  return origin.startsWith("http://localhost") ? "https://dev.weddingly.io" : origin;
};

const useTnC = () => {
  const [tncHTML, setTncHTML] = useState("");

  const fetchTnC = useCallback(() => {
    let Req = {
      method: "GET",
      baseURL: getBaseUrl() + "/api/legal-infos/TERMS_AND_CONDITIONS",
    };
    axios(Req)
      .then((Res) => {
        setTncHTML(Res.data.content);
      })
      .catch((Err) => {
        console.log("err fetch tnc", Err);
      });
  }, []);

  useEffect(() => {
    fetchTnC();
  }, [fetchTnC]);

  return { tncHTML, fetchTnC };
};

export default useTnC;
